import * as Yup from 'yup';
import { ClientBusinessModel } from 'app/client/clientBusiness/models/ClientBusiness';
import {
  transferReservationBaseFormValidation,
  transferReservationBaseLocationFormValidation
} from '../../../viajeTraslado/forms/base/TransferReservationBaseFormValidation';
import {
  TIPOS_SERVICIO_VIAJE_TRASLADO,
  ViajeTrasladoTipoServicio
} from '../../models';
/* import moment from 'moment'; */

export const transferReservationBatchLocationFormValidation =
  transferReservationBaseLocationFormValidation;

export const transferReservationBatchTripFormValidation = Yup.object().shape({
  tipoServicio: Yup.mixed()
    .required('El tipo de servicio es obligatorio')
    .oneOf(TIPOS_SERVICIO_VIAJE_TRASLADO),
  bus_type_id: Yup.mixed().when('tipoServicio', {
    is: ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES,
    then: (schema) => schema.required('El tipo de bus es requerido'),
  }),
  bus_customer_price: Yup.mixed().when('tipoServicio', {
    is: ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES,
    then: (schema) =>
      schema.required('El costo del cliente es requerido'),
  }),
  bus_provider_price: Yup.mixed().when('tipoServicio', {
    is: ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES,
    then: (schema) =>
      schema.required('El costo del proveedor es requerido'),
  }),
  prioridad: Yup.boolean(),
  hasOutSite: Yup.boolean(),
  fechaYHoraDeLlegada: Yup.mixed().required('La fecha de llegada es requerida'),
  minutosPreviosASalida: Yup.mixed().required(
    'Los minutos de salida son requeridos'
  ),
  puntos: Yup.array()
    .min(2, 'Debe haber al menos dos puntos')
    .of(transferReservationBatchLocationFormValidation)
});

export const transferReservationBatchFormValidation = (
  cliente: ClientBusinessModel | undefined,
  isLLTPais: boolean,
  withPhoneValidation: boolean
) =>
  transferReservationBaseFormValidation(cliente, withPhoneValidation).shape({
    viajes: Yup.array()
      .min(1, 'Debe haber al menos un viaje')
      .of(transferReservationBatchTripFormValidation),
    providerPrice: isLLTPais
      ? Yup.number().required('El costo del proveedor es requerido')
      : Yup.number().nullable(),
    customerPrice: isLLTPais
      ? Yup.number().required('El costo del cliente es requerido')
      : Yup.number().nullable()
  });
